import styles from './delete-price-dialog.module.scss';
import { useContext, useState } from 'react';
import { makeCourseRequest, useCourseGetRequestHook } from '../../../../requestUtils';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, Typography, toCurrency } from '@frontend-workspace/react-shared-lib';
import { IPrice } from '../../../../_models/price';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DeletePriceDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  priceId: string
}

export function DeletePriceDialog(props: DeletePriceDialogProps) {
  const { data: price }: { data: IPrice } = useCourseGetRequestHook(`resource/price/${props.priceId}`, undefined);

  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);

  const handleDeletePrice = () => {
    setLoading(true);
    makeCourseRequest(`resource/price/delete/${props.priceId}`, 'DELETE').then(result => {
      setSnackbarMessage({ content: t('deletePrice.deletedPriceFromList'), type: "success" });
      setLoading(false);
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('deletePrice.couldNotDeletePriceFromList'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('deletePrice.areYouSureYouWantToDeletePrice')}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-3'>
          {toCurrency(price?.value)}
        </Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          color='error'
          onClick={handleDeletePrice}
          disabled={loading}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('standard.delete')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeletePriceDialog;
